import { AGENT } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getHistoryFormattedTimestamp } from 'conversations-message-history/util/getHistoryFormattedTimestamp';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getOfficeHoursStartTime } from 'conversations-message-history/office-hours-message/operators/officeHoursMessageGetters';
import { getPlainText, getTimestamp
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PureComponent } from 'react';
import SlottedMessage from '../slotted-message/SlottedMessage';
import AutomatedMessageAvatar from '../avatar/AutomatedMessageAvatar';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OfficeHoursAnnotation = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-message-history.availability.small"
  }), /*#__PURE__*/_jsx(HelpIcon, {
    marginInline: "100",
    tooltipPlacement: "bottom",
    color: "icon-core-subtle",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.availability.tooltip"
    })
  })]
});
OfficeHoursAnnotation.displayName = 'OfficeHoursAnnotation';
export default class OfficeHoursMessage extends PureComponent {
  render() {
    const {
      message,
      positionDescriptors
    } = this.props;
    const startTime = getOfficeHoursStartTime(message);
    const plainText = getPlainText(message);
    const sameTime = plainText && plainText.includes(getHistoryFormattedTimestamp(startTime));
    const timestamp = getTimestamp(message);
    return /*#__PURE__*/_jsx(SlottedMessage, {
      container: {
        componentProps: {
          positionDescriptors,
          use: AGENT
        }
      },
      avatar: {
        Component: AutomatedMessageAvatar
      },
      title: {
        Component: FormattedMessage,
        componentProps: {
          message: 'conversations-inbox-message-history.responder.automatic'
        }
      },
      timestamp: {
        componentProps: {
          timestamp
        }
      },
      body: {
        componentProps: {
          contentText: getPlainText(message)
        }
      },
      annotation: !sameTime ? {
        // eslint-disable-next-line react/display-name
        Component: OfficeHoursAnnotation
      } : null
    });
  }
}
OfficeHoursMessage.displayName = 'OfficeHoursMessage';
OfficeHoursMessage.propTypes = {
  message: RecordPropType('OfficeHoursMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};